function getLinkedAccordion(hash) {
  if (!hash) return null;

  try {
    const target = document.querySelector(hash);
    if (
      target instanceof HTMLDetailsElement &&
      target.classList.contains('accordion')
    ) {
      return target;
    }
  } catch {
    return null;
  }

  return null;
}

function openAndScrollToAccordion(accordion, updateHash = false) {
  accordion.open = true;

  if (updateHash) {
    history.pushState(null, '', `#${accordion.id}`);
  }

  requestAnimationFrame(() => {
    accordion.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const linkedAccordion = getLinkedAccordion(window.location.hash);
  if (linkedAccordion) {
    openAndScrollToAccordion(linkedAccordion);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const accordion = getLinkedAccordion(link.hash);
    if (!accordion) return;

    event.preventDefault();
    openAndScrollToAccordion(accordion, true);
  });
});
